import { defineStore } from 'pinia';
import { axios } from '../axios';

export const useEncuestasStore = defineStore('encuestas', {
  state: () => ({
    encuestas: [],
    loadingEncuestas: false,
    errorEncuestas: null,
  }),

  actions: {
    async fetchEncuestas() {
      this.loadingEncuestas = true;
      this.errorEncuestas = null;

      try {
        const { data } = await axios.get('encuestas/');
        this.encuestas = data;
      } catch (err) {
        console.error('Error fetching encuestas:', err);
        this.errorEncuestas = err;
      } finally {
        this.loadingEncuestas = false;
      }
    },
  },
});
